function quickshopCnvString(key, fallback) {
  const s = window.theme && window.theme.strings && window.theme.strings[key];
  if (typeof s === "string" && s.length) return s;
  return fallback;
}

/**
 * Single source of truth for grid / Nosto SKU variant add-to-cart (see data-listener-added).
 */
function bindSkuListAddToCartButtons() {
  document
    .querySelectorAll(
      '.quickshop .sku-container-new .sku-item, .template-cart .nosto-list-item .sku-item, .sku-list-new .sku-item',
    )
    .forEach((item) => {
      if (item.hasAttribute('data-listener-added')) return;
      item.setAttribute('data-listener-added', 'true');
      item.addEventListener('click', () => {
        const variantId = item.getAttribute('data-variant-id');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then((response) => response.json())
          .then((data) => {
            document.dispatchEvent(new Event('cart:build'));
            if (!document.querySelector('#cnv-cart-popup-style')) {
              const style = document.createElement('style');
              style.id = 'cnv-cart-popup-style';
              style.textContent = `
    .cnv-cart-popup {
      position: fixed;
      align-items: center;
      justify-content: center;
      flex-direction: row-reverse;
      gap: 2px;
      top: 20px;
      right: 20px;
      background: #fff;
      border: 1px solid #ddd;
      box-shadow: 0 4px 16px rgba(0,0,0,0.15);
      border-radius: 4px;
      padding: 12px;
      max-width: 300px;
      z-index: 9999;
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease, transform 0.3s ease;
      transform: translateY(-10px);
      font-family: inherit;
    }
    .cnv-cart-popup.show {
      display: flex;
      opacity: 1;
      transform: translateY(0);
    }
    .cnv-cart-popup img {
      width: 60px;
      height: auto;
      float: left;
      margin-right: 10px;
      border-radius: 2px;
    }
    .cnv-cart-popup .details {
      overflow: hidden;
      font-size: 12px;
    }
    .cnv-cart-popup .title {
      font-weight: 400;
      margin-bottom: 4px;
    }
    .cnv-cart-popup .checkout-btn {
      display: block;
      text-align: center;
      margin-top: 10px;
      background: #000;
      color: #fff;
      padding: 10px;
      font-weight: 600;
      text-decoration: none;
    }
    .cnv-cart-popup .close-btn {
      position: relative;
      background: none;
      border: none;
      font-size: 18px;
      line-height: 1;
      cursor: pointer;
      color: #999;
      padding: 4px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cnv-cart-popup .close-btn:hover {
      color: #333;
    }
  `;
              document.head.appendChild(style);
            }

            const popup = document.createElement('div');
            popup.className = 'cnv-cart-popup';
            document.body.appendChild(popup);

            function closePopup() {
              popup.classList.remove('show');
              setTimeout(() => (popup.style.display = 'none'), 300);
            }

            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then((r) => r.json())
              .then((cart) => {
                if (!cart || !cart.items?.length) return;
                const cartItem = cart.items[0];
                const cnvLineTpl = quickshopCnvString(
                  'cnvCartPopupLine',
                  '[product_title] added to cart.',
                );
                const popupLine = cnvLineTpl.replace(
                  '[product_title]',
                  String(cartItem.product_title || ''),
                );
                const closeLabel = quickshopCnvString('cnvCartPopupClose', 'Close');

                popup.innerHTML = `
      <button class="close-btn" aria-label="${closeLabel}">×</button>
      <div class="details">
        <div class="title">${popupLine}</div>
      </div>
    `;

                popup.querySelector('.close-btn').addEventListener('click', closePopup);

                popup.style.display = 'block';
                requestAnimationFrame(() => popup.classList.add('show'));

                setTimeout(closePopup, 5000);
              })
              .catch(console.error);
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
          });
      });
    });
}

document.addEventListener('DOMContentLoaded', () => {
  

  function updateProductHandles() {
  // Check if all required elements are present
  const elements = document.querySelectorAll('.nosto-recs-template-last .nosto-bottom-bar [data-product-handle]');
  if (!elements.length) {
    return; // Exit if elements are not yet loaded
  }

  // Loop through each element and update the data-product-handle attribute
  elements.forEach(element => {
    const fullUrl = element.getAttribute('data-product-handle');
    
    if (fullUrl) {
      const cleanHandle = fullUrl.split('?')[0].split('/').pop();
      element.setAttribute('data-product-handle', cleanHandle);
    }
  });


    
}

// hide quickshop badges logic
function hideQuickShopBadges(){
      const productBadgeContainers = document.querySelectorAll('.quickshop .product-badges');
      
        productBadgeContainers.forEach(container => {
          const badges = container.querySelectorAll('.badge');
          if (badges.length > 1) {
            let highestZIndex = -Infinity;
            let highestZIndexBadge = null;
      
            badges.forEach(badge => {
              const zIndex = parseInt(window.getComputedStyle(badge).zIndex);
              if (!isNaN(zIndex) && zIndex > highestZIndex) {
                highestZIndex = zIndex;
                highestZIndexBadge = badge;
              }
            });
      
            badges.forEach(badge => {
              if (badge !== highestZIndexBadge) {
                badge.style.opacity = '0'; // Adjust opacity value as needed
              }
            });
          }
        });
}


// Wait until all elements are loaded before running the update function
function checkElementsLoaded() {
  const elements = document.querySelectorAll('.nosto-recs-template-last .nosto-bottom-bar');
  if (elements.length && Array.from(elements).every(el => el.offsetParent !== null)) {
    updateProductHandles(); // Run the update function
    window._swat.fetch(function(r) {
      // console.log('window.myWishList', r)
      window.myWishList = r;

      if (window.myWishList.length > 0) {
        document.querySelector('.wishlist-link__bubble').classList.add('wishlist-link__bubble--visible');
      } else {
        document.querySelector('.wishlist-link__bubble').classList.remove('wishlist-link__bubble--visible');
      };

      
        const wishlistButtons = document.querySelectorAll('.wishlist');
        if (wishlistButtons.length == 0) return;

        wishlistButtons.forEach(function(button) {
          const empi = button.getAttribute('data-empi');
          const epi = button.getAttribute('data-epi');
          if (empi || epi) {
            const matching_arr = window.myWishList.filter(i => i.empi == empi || i.epi == epi);
            if (matching_arr.length == 0) return;
            button.classList.add('is-saved');
          }
        })
      
    });
  } else {
    requestAnimationFrame(checkElementsLoaded); // Check again on the next frame
  }
}

// Start the checking process
checkElementsLoaded();

  
  function loadQuickShopImages(slider) {
    slider.querySelectorAll('img[data-src]').forEach((img) => {
      const template = img.getAttribute('data-src');
      if (!template || img.getAttribute('src')) return;

      img.setAttribute('src', template.replace('{width}', '540'));
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
    });
  }

  function initQuickShopPhotoSlider(slider) {
    loadQuickShopImages(slider);

    const existingInstance = Flickity.data(slider);
    if (existingInstance) existingInstance.destroy();

    const flkty = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      draggable: true,
    });

    if (!slider.hasAttribute('data-quickshop-wheel')) {
      slider.setAttribute('data-quickshop-wheel', '');
      let wheelLock = false;
      let accumulated = 0;
      let wheelTimer = 0;

      slider.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

        event.preventDefault();
        if (wheelLock) return;

        const sliderInstance = Flickity.data(slider);
        if (!sliderInstance) return;

        const distance = event.deltaMode === 1
          ? event.deltaX * 16
          : event.deltaMode === 2
            ? event.deltaX * slider.clientWidth
            : event.deltaX;

        accumulated += distance;
        if (Math.abs(accumulated) < 120) return;

        wheelLock = true;
        accumulated = 0;
        if (distance > 0) sliderInstance.next();
        else sliderInstance.previous();

        window.clearTimeout(wheelTimer);
        wheelTimer = window.setTimeout(() => {
          wheelLock = false;
          accumulated = 0;
        }, 700);
      }, { passive: false });
    }

    const resize = () => flkty.resize();
    slider.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', resize, { once: true });
    });
    revealQuickShopGallery(slider);
  }

  function bindQuickShopNostoTrackpad() {
    if (window.__quickshopNostoTrackpad) return;
    window.__quickshopNostoTrackpad = true;

    const state = new WeakMap();

    document.addEventListener('wheel', (event) => {
      const slider = event.target.closest && event.target.closest('.quickshop .nosto-list.flickity-enabled, .quickshop .nosto-bundle-list.flickity-enabled');
      if (!slider) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

      const flkty = typeof Flickity !== 'undefined' && Flickity.data(slider);
      if (!flkty) return;

      event.preventDefault();

      let slide = state.get(slider);
      if (!slide) {
        slide = { locked: false, accumulated: 0, timer: 0 };
        state.set(slider, slide);
      }
      if (slide.locked) return;

      const distance = event.deltaMode === 1
        ? event.deltaX * 16
        : event.deltaMode === 2
          ? event.deltaX * slider.clientWidth
          : event.deltaX;

      slide.accumulated += distance;
      if (Math.abs(slide.accumulated) < 48) return;

      slide.locked = true;
      if (slide.accumulated > 0) flkty.next();
      else flkty.previous();
      slide.accumulated = 0;

      window.clearTimeout(slide.timer);
      slide.timer = window.setTimeout(() => {
        slide.locked = false;
        slide.accumulated = 0;
      }, 280);
    }, { passive: false, capture: true });
  }

  bindQuickShopNostoTrackpad();

  function resizeQuickShopNostoSliders(scope) {
    const root = scope && scope.querySelectorAll ? scope : document.querySelector('#quickshop');
    if (!root) return;

    root.querySelectorAll('.nosto-list, .nosto-bundle-list').forEach((slider) => {
      slider.style.minHeight = '';
      const flkty = typeof Flickity !== 'undefined' && Flickity.data(slider);
      if (!flkty) return;

      flkty.resize();
    });
  }

  function watchQuickShopNostoSliders() {
    const root = document.querySelector('#quickshop');
    if (!root || root.dataset.nostoResizeWatch) return;

    root.dataset.nostoResizeWatch = 'true';
    let timer = 0;
    const observer = new MutationObserver(() => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => resizeQuickShopNostoSliders(root), 80);
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  watchQuickShopNostoSliders();

  function revealQuickShopGallery(slider) {
    const photos = slider.closest('.product__main-photos');
    if (!photos || photos.classList.contains('is-ready')) return;

    const img = slider.querySelector('.product-main-slide.is-selected img')
      || slider.querySelector('img');
    const show = () => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => photos.classList.add('is-ready'));
      });
    };

    if (!img || img.complete) {
      show();
      return;
    }

    img.addEventListener('load', show, { once: true });
  }
  window.revealQuickShopGallery = revealQuickShopGallery;

  function disableQuickShopZoom(root) {
    const scope = root || document.querySelector('.quickshop');
    if (!scope) return;

    scope.querySelectorAll('[data-image-zoom]').forEach((node) => {
      node.removeAttribute('data-image-zoom');
    });
    scope.querySelectorAll('[data-zoom]').forEach((node) => {
      node.setAttribute('data-zoom', 'false');
    });
    scope.querySelectorAll('.js-photoswipe__zoom').forEach((node) => {
      node.remove();
    });
  }

  function reinitializeQuickShopSliders() {
    disableQuickShopZoom();
    document.querySelectorAll('.quickshop .product-slideshow').forEach(loadQuickShopImages);

    requestAnimationFrame(() => {
      document.querySelectorAll('.quickshop .product-slideshow').forEach(initQuickShopPhotoSlider);
      resizeQuickShopNostoSliders(document.querySelector('#quickshop'));
    });

    setTimeout(() => {
      const quickShopColorVariantSliders = document.querySelectorAll('.quickshop .product-single__color-variants');
      quickShopColorVariantSliders.forEach((slider) => {
        const colorVariantItems = slider.querySelectorAll('.quickshop .product-single__color-variant');
        if (colorVariantItems.length > 4) {
          const qsflickityInstance = Flickity.data(slider);
          if (qsflickityInstance) {
            qsflickityInstance.destroy();
          }
          new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: true,
            draggable: true,
          });
        }
      });

        const productBadgeContainersQ = document.querySelectorAll('.template-product .product-badges, .quickshop .product-badges');
      
        productBadgeContainersQ.forEach(container => {
          const badges = container.querySelectorAll('.badge');
          if (badges.length > 1) {
            let highestZIndex = -Infinity;
            let highestZIndexBadge = null;
      
            badges.forEach(badge => {
              const zIndex = parseInt(window.getComputedStyle(badge).zIndex);
              if (!isNaN(zIndex) && zIndex > highestZIndex) {
                highestZIndex = zIndex;
                highestZIndexBadge = badge;
              }
            });
      
            badges.forEach(badge => {
              if (badge !== highestZIndexBadge) {
                badge.style.opacity = '0'; // Adjust opacity value as needed
              }
            });
          }
        });
    }, 300); 

    
  }

  let quickshopOpener = null;
  let quickshopReviewsOpener = null;

  function focusDrawer(container, selector) {
    if (!container) return;
    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-modal', 'true');
    const target = (selector && container.querySelector(selector))
      || container.querySelector('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (target) {
      target.focus();
      return;
    }
    if (!container.hasAttribute('tabindex')) container.setAttribute('tabindex', '-1');
    container.focus();
  }

  function focusQuickShopDrawer() {
    const quickshop = document.querySelector('.quickshop');
    if (quickshop) {
      for (const zoom of quickshop.querySelectorAll('.product-slideshow .js-photoswipe__zoom')) {
        zoom.setAttribute('tabindex', '-1');
      }
    }
    if (!quickshop) return;
    quickshop.setAttribute('aria-labelledby', 'QuickShopTitle');
    const closeButton = Array.from(quickshop.querySelectorAll('.quickshop-header .drawer__close-button')).find((button) => button.getClientRects().length > 0);
    if (closeButton) {
      closeButton.focus();
      return;
    }
    focusDrawer(quickshop, '.quickshop-header .drawer__close-button');
  }
  window.focusQuickShopDrawer = focusQuickShopDrawer;

  function quickShopCloseLabel() {
    const label = window.theme && window.theme.strings && window.theme.strings.cnvCartPopupClose;
    return label || 'Close';
  }

  function escapeQuickShopText(value) {
    return String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[character]);
  }

  function quickShopTitleLabel() {
    const label = window.theme && window.theme.strings && window.theme.strings.quickShopTitle;
    if (!label || String(label).indexOf('Translation missing') !== -1) return 'Quick shop';
    return label;
  }

  function quickShopHeaderHtml() {
    const closeLabel = escapeQuickShopText(quickShopCloseLabel());
    const titleLabel = escapeQuickShopText(quickShopTitleLabel());

    return `
      <div class="quickshop-header">
        <div class="quickshop-header__mobile">
          <div class="drawer__empty-right"></div>
          <div class="drawer__close">
            <button type="button" class="drawer__close-button js-drawer-close">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="19.799" height="19.799" viewBox="0 0 19.799 19.799">
                <g id="Group_4" data-name="Group 4" transform="translate(0.707 0.707)">
                  <line id="Line_1" data-name="Line 1" x2="26" transform="translate(0 0) rotate(45)" fill="none" stroke="#222" stroke-width="2"/>
                  <line id="Line_2" data-name="Line 2" x2="26" transform="translate(0 18.385) rotate(-45)" fill="none" stroke="#222" stroke-width="2"/>
                </g>
              </svg>
              <span class="icon__fallback-text">${closeLabel}</span>
            </button>
          </div>
          <div class="h1 site-header__logo" itemscope="" itemtype="https://schema.org/Organization" aria-label="to homepage">
            <a href="/" itemprop="url" class="site-header__logo-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="98.439" height="26" viewBox="0 0 404.29 98.61"><polygon points="95.05 8.05 112.93 8.05 112.93 98.44 95.05 98.22 95.05 8.05" fill="currentColor"></polygon><path d="M336.18,243h17.93v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86s10.6-17.86,36.25-17.86c37.4,0,43.08,35.8,43.08,36.89v53.66H479l0-49.62s-.95-22.95-26-22.9c-24.85,0-27.52,22.9-27.52,22.9v49.61H407.67l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9l-.06,49.62H336.18Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M306.88,243l-.05,90.39h-18v-8s-13.35,9.15-26.26,8c-1.1-.11-43.47,1.11-44.35-47.13C218,245.49,258.12,243,258.12,243Zm-45.12,17.82s-25.49-2.35-25.71,25.51c1.8,29.34,26.81,28.7,26.81,28.7s22.95,1.9,25.91-21.78V260.86Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M501.08,243.1H519v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86a38.24,38.24,0,0,1,8.73,23.07c0,1.76,0,49.61,0,49.61H572.57l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9L519,333.48H501.08Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M495.61,235l-16.31,0,0,8.81a39.37,39.37,0,0,1,8.22,7.26c1.49,1.82,2.34,1.43,8.07,12.58Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M591.18,258.69c0-9.11,6.49-15.76,15.68-15.76s15.6,6.65,15.6,15.76-6.49,15.83-15.6,15.83S591.18,267.8,591.18,258.69Zm4.31,0c0,6.85,4.38,11.65,11.3,11.65s11.37-4.8,11.37-11.65S613.64,247,606.79,247,595.49,251.84,595.49,258.69Zm14.69,1.7,4.33,6.41-4.87.08-3.71-6.18h-1.31v6.18h-4v-16.6H608c3.47,0,5.79,2,5.79,5.17A4.92,4.92,0,0,1,610.18,260.39Zm-5.56-6.49v3.48h3.17a1.77,1.77,0,0,0,2-1.78c0-1.23-.93-1.7-2-1.7Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path></svg>
            </a>
          </div>
        </div>
        <div class="quickshop-header__desktop">
          <h2 class="quickshop-header__title" id="QuickShopTitle">${titleLabel}</h2>
          <button type="button" class="quickshop-header__close drawer__close-button js-drawer-close">
            <span class="visually-hidden">${closeLabel}</span>
            <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="18" height="18">
              <path d="M4 4l12 12M16 4 4 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"></path>
            </svg>
          </button>
        </div>
      </div>
    `;
  }

  window.quickShopHeaderHtml = quickShopHeaderHtml;

  function updateProductDetails(productUrl) {
    const newTitle = document.querySelector('.quickshop .product-single__title').textContent;
    document.title = newTitle;
    initNoDrawerCheckoutCTA();
  }

  function onVariantChange({ target: optionValueElement }) {
    const productElement = document.querySelector('.quickshop .combined-product');
    const sectionId = document.querySelector('.quickshop #productSection').dataset.sectionId;
    const oldProductUrl = productElement.dataset.productUrl;
    const newProductUrl = optionValueElement.dataset.productUrl;
    const productUrl = newProductUrl ? newProductUrl : oldProductUrl;
    const newVariantId = optionValueElement.dataset.variantId;
    let params = `section_id=${sectionId}&`;

    if (newVariantId) {
      params += `variant=${newVariantId}`;
    } else {
      const selectedOptionValues = Array.from(document.querySelectorAll('.quickshop fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
      params += `option_values=${selectedOptionValues}`;
    }

    document.querySelectorAll('.quickshop variant-input').forEach(div => div.classList.remove('selected'));
    document.querySelectorAll('.quickshop input[type="radio"]').forEach(input => input.classList.remove('selected'));

    optionValueElement.classList.add('selected');
    optionValueElement.closest('.variant-input').classList.add('selected');

    fetch(`${productUrl}?${params}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        if (newProductUrl && oldProductUrl !== newProductUrl) {
          productElement.parentNode.insertBefore(html.querySelector('.combined-product'), productElement);
          productElement.remove();

          updateProductDetails(newProductUrl);
          reinitializeQuickShopSliders();
          if (typeof window.cleanupPdpLengthNoticeOrphans === 'function') window.cleanupPdpLengthNoticeOrphans();
          if (typeof window.initPdpLengthNoticeIn === 'function') {
            var cpLenQs = document.querySelector('.quickshop .combined-product');
            if (cpLenQs) window.initPdpLengthNoticeIn(cpLenQs);
          }

          document.querySelectorAll('.quickshop .size-selector-button').forEach(function(button) {
            button.addEventListener('click', function() {
              theme.SizeGuideModal.open();
            });
          });

          document.querySelector(`#${optionValueElement.id}`).focus();

          if (window.theme && typeof window.theme.initPdpWishlist === 'function') {
            window.theme.initPdpWishlist(document.querySelector('.quickshop'));
          }
          initNoDrawerCheckoutCTA();
          return;
        }

        document.querySelector('.quickshop .optionValueSelectors').innerHTML = html.querySelector('.optionValueSelectors').innerHTML;

        if (typeof window.cleanupPdpLengthNoticeOrphans === 'function') window.cleanupPdpLengthNoticeOrphans();
        if (typeof window.initPdpLengthNoticeIn === 'function') {
          var ovsLenQs = document.querySelector('.quickshop .optionValueSelectors');
          if (ovsLenQs) window.initPdpLengthNoticeIn(ovsLenQs);
        }

        document.querySelector(`#${optionValueElement.id}`).focus();

        const priceEl = document.querySelector('.quickshop .product__price');
        if (html.querySelector('.product__price')) {
          priceEl.innerHTML = html.querySelector('.product__price').innerHTML;
        } else {
          priceEl.innerHTML = '';
        }

        document.querySelectorAll('.quickshop .size-selector-button').forEach(function(button) {
          button.addEventListener('click', function() {
            theme.SizeGuideModal.open();
          });
        });

        const addToCartForm = document.querySelector('.quickshop .product-form');
        const newVariantInput = html.querySelector('.product-form input[name="id"]');
        if (addToCartForm && newVariantInput) {
          const hiddenId = addToCartForm.querySelector('input[name="id"]');
          if (hiddenId) hiddenId.value = newVariantInput.value;
        }
        if (window.theme && typeof window.theme.updatePdpWishlistFromHtml === 'function') {
          window.theme.updatePdpWishlistFromHtml(document.querySelector('.quickshop'), html);
        }
      });
  }

  let quickShopColorRequest = 0;

  function quickShopSectionUrl(productUrl) {
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', 'product-template');
    return url.pathname + url.search;
  }

  function mountQuickShopSection(sectionHtml) {
    const content = document.querySelector('.quickshop .quickshop-content');
    if (!content) return;

    content.innerHTML = sectionHtml;

    const quickshop = document.querySelector('.quickshop');
    if (window.theme && typeof window.theme.initQuickshopWishlist === 'function') {
      window.theme.initQuickshopWishlist(quickshop);
    }

    reinitializeQuickShopSliders();
    hideQuickShopBadges();
    if (window.lipscore && typeof window.lipscore.reInitWidgets === 'function') {
      window.lipscore.reInitWidgets();
    }
    if (quickshop) bindQuickShopReviews(quickshop);

    document.querySelectorAll('.quickshop .size-selector-button').forEach((button) => {
      button.addEventListener('click', () => {
        theme.SizeGuideModal.open();
      });
    });

    if (typeof window.cleanupPdpLengthNoticeOrphans === 'function') window.cleanupPdpLengthNoticeOrphans();
    if (typeof window.initPdpLengthNoticeIn === 'function') {
      const product = document.querySelector('.quickshop .combined-product');
      if (product) window.initPdpLengthNoticeIn(product);
    }
    if (typeof initNoDrawerCheckoutCTA === 'function') initNoDrawerCheckoutCTA();
    if (typeof bindSkuListAddToCartButtons === 'function') bindSkuListAddToCartButtons();

    const section = document.querySelector('.quickshop #productSection');
    if (section) section.addEventListener('change', onVariantChange);

    const current = document.querySelector('.quickshop a.product-single__color-variant.current');
    if (current) current.focus();
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('.quickshop a.product-single__color-variant');
    if (!link) return;

    event.preventDefault();
    if (link.classList.contains('current')) return;

    const href = link.getAttribute('href');
    if (!href) return;

    const requestId = ++quickShopColorRequest;
    const content = document.querySelector('.quickshop .quickshop-content');
    if (content) content.setAttribute('aria-busy', 'true');

    fetch(quickShopSectionUrl(href))
      .then((response) => {
        if (!response.ok) throw new Error('Failed to render product section.');
        return response.text();
      })
      .then((sectionHtml) => {
        if (requestId !== quickShopColorRequest) return;
        mountQuickShopSection(sectionHtml);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        if (requestId !== quickShopColorRequest) return;
        const currentContent = document.querySelector('.quickshop .quickshop-content');
        if (currentContent) currentContent.removeAttribute('aria-busy');
      });
  });

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest && event.target.closest('.quickshop .product-slideshow .flickity-prev-next-button');
    if (!arrow) return;

    const slider = arrow.closest('.product-slideshow');
    setTimeout(() => {
      if (!arrow.disabled) return;
      const other = slider.querySelector('.flickity-prev-next-button:not([disabled])');
      if (other) other.focus();
      else slider.focus();
    }, 0);
  });

  function closeQuickShopReviews(reviews) {
    if (!reviews) return;
    reviews.classList.remove('open');
    const back = quickshopReviewsOpener;
    quickshopReviewsOpener = null;
    if (back && document.contains(back)) {
      if (back.tabIndex < 0) back.setAttribute('tabindex', '-1');
      back.focus();
      return;
    }
    focusQuickShopDrawer();
  }

  function closeQuickShopDrawer() {
    const quickshop = document.querySelector('.quickshop');
    const back = quickshopOpener;
    quickshopOpener = null;
    quickshopReviewsOpener = null;
    if (!quickshop || !quickshop.classList.contains('open')) return;

    quickshop.classList.remove('open');
    const overlay = document.querySelector('.quickshop-overlay');
    if (overlay) overlay.classList.remove('is-visible');
    if (back && document.contains(back)) back.focus();

    const finish = () => {
      if (overlay && overlay.parentNode && !overlay.classList.contains('is-visible')) overlay.remove();
      if (quickshop.classList.contains('open')) return;
      quickshop.innerHTML = '';
      quickshop.style.display = '';
    };

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      finish();
      return;
    }

    let settled = false;
    const done = (event) => {
      if (event && (event.target !== quickshop || event.propertyName !== 'transform')) return;
      if (settled) return;
      settled = true;
      quickshop.removeEventListener('transitionend', done);
      finish();
    };

    quickshop.addEventListener('transitionend', done);
    window.setTimeout(done, 450);
  }

  window.closeQuickShopDrawer = closeQuickShopDrawer;

  document.addEventListener('pointerdown', (event) => {
    const opener = event.target.closest && event.target.closest('.mobile-atc-size-drawer');
    if (opener) quickshopOpener = opener;
  }, true);

  document.addEventListener('pointerdown', (event) => {
    const quickshop = document.querySelector('.quickshop.open');
    if (!quickshop || !quickshop.getClientRects().length || quickshop.contains(event.target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    closeQuickShopDrawer();
  }, true);

  function topOpenDrawer() {
    const quickshop = document.querySelector('.quickshop.open');
    if (quickshop) {
      const reviews = quickshop.querySelector('#reviewDrawer.open');
      return reviews || quickshop;
    }
    const pageReviews = document.querySelector('#reviewDrawer.open');
    if (pageReviews && !pageReviews.closest('.quickshop')) return pageReviews;
    return null;
  }

  function focusableIn(container) {
    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((node) => {
      return node.tabIndex >= 0 && !node.closest('[hidden]') && node.getClientRects().length > 0;
    });
  }

  function keepFocusInside(event) {
    const drawer = topOpenDrawer();
    if (!drawer) return;
    const focusable = focusableIn(drawer);
    if (!focusable.length) {
      event.preventDefault();
      if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
      drawer.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const inside = event.target === drawer || drawer.contains(event.target);
    if (!inside) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      keepFocusInside(event);
      return;
    }
    if (event.key !== 'Escape') return;

    const quickshop = document.querySelector('.quickshop.open');
    if (quickshop) {
      const reviews = quickshop.querySelector('#reviewDrawer.open');
      if (reviews) {
        event.preventDefault();
        closeQuickShopReviews(reviews);
        return;
      }
      event.preventDefault();
      closeQuickShopDrawer();
      return;
    }

    const pageReviews = document.querySelector('#reviewDrawer.open');
    if (!pageReviews || pageReviews.closest('.quickshop')) return;
    event.preventDefault();
    pageReviews.classList.remove('open');
    document.querySelectorAll('.drawer__overlay.active').forEach((overlay) => {
      overlay.classList.remove('active');
    });
    document.body.style.overflow = '';
  });

  document.addEventListener('focusin', (event) => {
    const drawer = topOpenDrawer();
    if (!drawer || event.target === drawer || drawer.contains(event.target)) return;
    const focusable = focusableIn(drawer);
    if (focusable.length) focusable[0].focus();
    else drawer.focus();
  });

  function bindQuickShopReviews(root) {
    const drawer = root.querySelector('#reviewDrawer');
    if (!drawer) return;

    const countEl = root.querySelector('.lipscore-review-count');

    function reviewCount() {
      const current = root.querySelector('.lipscore-review-count');
      if (!current) return null;
      const digits = (current.textContent || '').replace(/[^\d]/g, '');
      if (!digits) return null;
      return parseInt(digits, 10);
    }

    function applyReviewVisibility() {
      const count = reviewCount();
      if (count === null || Number.isNaN(count)) return false;

      const show = count > 0;
      root.querySelectorAll('.lipscore-rating-small').forEach((node) => {
        node.hidden = !show;
        node.style.display = show ? '' : 'none';
      });

      if (!show) {
        const openDrawer = root.querySelector('#reviewDrawer');
        if (openDrawer) openDrawer.classList.remove('open');
      }
      return true;
    }

    function openQuickShopReviews(opener) {
      const currentDrawer = root.querySelector('#reviewDrawer');
      if (!currentDrawer || !opener || reviewCount() === 0) return;

      quickshopReviewsOpener = opener;
      currentDrawer.classList.add('open');
      focusDrawer(currentDrawer, '#closeDrawerBtn');

      if (window.lipscore && typeof window.lipscore.reInitWidgets === 'function') {
        window.lipscore.reInitWidgets();
      }
    }

    if (!root.hasAttribute('data-quickshop-reviews')) {
      root.setAttribute('data-quickshop-reviews', '');
      root.addEventListener('click', (event) => {
        const currentDrawer = root.querySelector('#reviewDrawer');
        if (!currentDrawer) return;

        if (event.target.closest('#closeDrawerBtn')) {
          closeQuickShopReviews(currentDrawer);
          return;
        }

        const opener = event.target.closest('.lipscore-rating-small, .openDrawerBtn');
        if (!opener || opener.closest('#reviewDrawer')) return;

        event.preventDefault();
        openQuickShopReviews(opener);
      });

      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const opener = event.target.closest('.lipscore-rating-small, .openDrawerBtn');
        if (!opener || opener.closest('#reviewDrawer')) return;

        event.preventDefault();
        openQuickShopReviews(opener);
      });
    }

    let tries = 0;
    const timer = window.setInterval(() => {
      if (applyReviewVisibility() || tries++ > 40) window.clearInterval(timer);
    }, 300);

    if (countEl && window.MutationObserver) {
      new MutationObserver(applyReviewVisibility).observe(countEl, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  function initializeQuickShop() {
    document.querySelectorAll('.mobile-atc-size-drawer').forEach(button => {
            if (button.hasAttribute('data-quickshop-initialized')) {
        return;
      }
      // Mark as initialized
      button.setAttribute('data-quickshop-initialized', 'true');
      button.addEventListener('pointerdown', async (event) => {

        console.log("wowza");
        event.preventDefault();
         const drawer = document.getElementById('quickshop');

        drawer.classList.add('open');
        
        const productHandle = button.getAttribute('data-product-handle');
        if (!productHandle) {
          console.error("Product handle not found.");
          return;
        }
        
        try {
          const response = await fetch(`/products/${productHandle}?view=ajax`);
          if (!response.ok) {
            throw new Error("Failed to fetch product page.");
          }
          
          const productHTML = await response.text();
          const ccartNostoCart = document.querySelector(".js-drawer-open-cart");
          const drawerContent = document.querySelector('.quickshop');
          if (drawerContent) {
            drawerContent.innerHTML = quickShopHeaderHtml() + '<div class="quickshop-content">' + productHTML + '</div>';

            if (window.theme && typeof window.theme.initQuickshopWishlist === 'function') {
              window.theme.initQuickshopWishlist(drawerContent);
            }
           
            reinitializeQuickShopSliders();
            hideQuickShopBadges();
            lipscore.reInitWidgets();
            bindQuickShopReviews(drawerContent);
            document.querySelectorAll('.size-selector-button').forEach(function(button) {

              button.addEventListener('click', function() {

                theme.SizeGuideModal.open();

              });

            });

            document.querySelectorAll('.quickshop-header .drawer__close-button').forEach((closeButton) => {
              closeButton.addEventListener('click', closeQuickShopDrawer);
            });
                         // Create and append overlay
            document.querySelectorAll('.quickshop-overlay').forEach((node) => node.remove());
            const overlay = document.createElement('div');
            overlay.className = 'quickshop-overlay';
            document.body.appendChild(overlay);
            window.requestAnimationFrame(() => overlay.classList.add('is-visible'));

            overlay.addEventListener('click', closeQuickShopDrawer);
            drawerContent.style.display = 'flex';
            focusQuickShopDrawer();
            // ccartNostoCart.click();
                // Add event listeners to variant input elements for selection logic
            document.querySelectorAll('.quickshop .variant-input').forEach(input => {
              input.addEventListener('click', () => {
                // Remove .var-inpt-selected from all other variant inputs within the quickshop container
                document.querySelectorAll('.quickshop .variant-input').forEach(el => {
                  el.classList.remove('var-inpt-selected');
                });
                // Add .var-inpt-selected to the clicked variant input
                input.classList.add('var-inpt-selected');
              });
            });
            
            // Add to cart logic
            // document.querySelectorAll('.quickshop .product-single__form .add-to-cart').forEach(button => {
            //   button.addEventListener('click', (event) => {
            //     event.preventDefault(); // Prevent default form submission
                
            //     const form = button.closest('.product-single__form');
            
            //     // Get the selected variant ID
            //     const selectedVariant = form.querySelector('.var-inpt-selected');
            //     if (!selectedVariant) {
            //       console.error('No variant selected');
            //       return;
            //     }
            //     const variantId = selectedVariant.getAttribute('data-variant-id');
                         
            //     const ccart = document.querySelector(".js-drawer-open-cart");
            
            //     fetch('/cart/add.js', {
            //       method: 'POST',
            //       headers: {
            //         'Content-Type': 'application/json'
            //       },
            //       body: JSON.stringify({ id: variantId, quantity: 1 })
            //     })
            //     .then(response => response.json())
            //     .then(data => {
            //       console.log('Added to cart');
            //       document.dispatchEvent(new Event('cart:build'));
            //       const quickshop = document.querySelector('.quickshop');
            //       if (quickshop) {
            //         quickshop.innerHTML = '';
            //         quickshop.style.display = 'none';
            //       }
            //       // setTimeout(() => {
    
            //       //   nostojs(function(api) {
            //       //     var request = api.createRecommendationRequest();
            //       //     document.querySelectorAll(".nosto-cart-el").forEach(function(element) {
            //       //       request.addElements([element.id]); 
            //       //     });
            //       //     request.loadRecommendations();
            //       //   });
    
            //       // }, 900); 
            //     })
            //     .catch(error => {
            //       console.error('Error adding to cart:', error);
            //     });
            //   });
            // });

//  function attachAddToCartEvent() {
//  // Remove the existing event listener to prevent multiple bindings
//     const addToCartForm = document.querySelector('.quickshop .combined-product .product-form');
//     const newAddToCartForm = addToCartForm.cloneNode(true);
//     // setTimeout(() => { const newAddToCartForm = addToCartForm.cloneNode(true); /* Your code using newAddToCartForm */ }, 1000);
//     addToCartForm.parentNode.replaceChild(newAddToCartForm, addToCartForm);

//     // Attach the new event listener for form submission
//     newAddToCartForm.addEventListener('submit', function(event) {
//       event.preventDefault(); // Prevent the default form submission behavior

//       // Collect the form data
//       const formData = new FormData(this);

//       // Perform the AJAX request to add the product to the cart
//       fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData,
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest', // Ensure the request is recognized as AJAX
//           'Accept': 'application/json' // Expect a JSON response from Shopify
//         }
//       })
//       .then(response => {
//         // Check if the response is OK, else throw an error
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then((data) => {
//         // Successfully added to cart, now open the cart drawer
//         document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: data }})); // Dispatch a custom event to update the cart
        
//         // nostojs(function(api) {
//         //   var request = api.createRecommendationRequest();
//         //   document.querySelectorAll(".nosto-cart-el").forEach(function(element) {
//         //     request.addElements([element.id]); 
//         //   });
//         //   request.loadRecommendations();
//         // });
        
//         const cartDrawer = document.querySelector('.js-drawer-open-cart');
//         if (cartDrawer) {
//           // cartDrawer.click(); // Open the cart drawer if the element exists
//         }
//         const quickshop = document.querySelector('.quickshop');
//                 if (quickshop) {
//                   quickshop.innerHTML = '';
//                   quickshop.style.display = 'none';
//                 }
//         // cartDrawer.click();
//       })
//       .catch(error => {
//         console.error('Error adding item to cart:', error);
//       });
//     });
//        setTimeout(function() {
//           yotpo.refreshWidgets();
//           setTimeout(function() {
//           var recensionerLinks = document.querySelectorAll('.yotpo-sr-bottom-line-text');
//           var reviewFound = false; // Flag to check if any review is found
        
//           recensionerLinks.forEach(function(link) {
//             var reviewText = link.textContent;
//             var reviewNumberMatch = reviewText.match(/\d+/); // Match any number in the text
        
//             if (reviewNumberMatch) {
//               var reviewNumber = parseInt(reviewNumberMatch[0], 10); // Extract and convert the number part to an integer
//               link.innerHTML = `(${reviewNumber})`;
        
//               if (reviewNumber > 0) {
//                 reviewFound = true; // Set flag to true if a review is found
//               }
//             }
//           });
          
//           var yotpoContStars = document.querySelectorAll('.yotpo-sr-bottom-line-summary');
//           yotpoContStars.forEach(function(element) {
//               element.style.opacity = '1';
//           });
//           }, 1500);
//     }, 100); 
//   }
            
    // setTimeout(function() {
    //       yotpo.refreshWidgets();
      
    //       setTimeout(function() {
    //       var recensionerLinks = document.querySelectorAll('.yotpo-sr-bottom-line-text');
    //       var reviewFound = false; // Flag to check if any review is found
        
    //       recensionerLinks.forEach(function(link) {
    //         var reviewText = link.textContent;
    //         var reviewNumberMatch = reviewText.match(/\d+/); // Match any number in the text
        
    //         if (reviewNumberMatch) {
    //           var reviewNumber = parseInt(reviewNumberMatch[0], 10); // Extract and convert the number part to an integer
    //           link.innerHTML = `(${reviewNumber})`;
        
    //           if (reviewNumber > 0) {
    //             reviewFound = true; // Set flag to true if a review is found
    //           }
    //         }
    //       });
          
    //         var yotpoContStars = document.querySelectorAll('.yotpo-sr-bottom-line-summary');
    //         yotpoContStars.forEach(function(element) {
    //             element.style.opacity = '1';
    //         });
    //       }, 500);
    // }, 100); 
            
        const quickshopproductSection = document.querySelector('.quickshop #productSection');
        if (quickshopproductSection) {
            quickshopproductSection.addEventListener('change', onVariantChange);
        }
          // attachAddToCartEvent();
          initNoDrawerCheckoutCTA();
          }
        } catch (error) {
          
          console.error("Error loading product page:", error);
        }
      });
    });

  
}

  // Use a MutationObserver to wait for .mobile-atc-size-drawer elements to load
const observer = new MutationObserver((mutationsList, observer) => {
  // Check if .mobile-atc-size-drawer elements are present
  if (document.querySelectorAll('.mobile-atc-size-drawer').length > 0) {
    setTimeout(initializeQuickShop, 500);
    // observer.disconnect(); // Disconnect after initialization
  }
  
  // if (document.querySelectorAll('.template-index .nosto-recs-template-last .mobile-atc-size-drawer').length > 0) {
  //   initializeQuickShop();
  //   observer.disconnect(); // Disconnect after initialization
  // }
  // Loop through mutations to find added .nosto-list-item elements
  mutationsList.forEach(mutation => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          // Check the node itself or its descendants
          if (node.matches && node.matches('.mobile-atc-size-drawer')) {
            setTimeout(initializeQuickShop, 500);
          } else if (node.querySelectorAll) {
            const newButtons = node.querySelectorAll('.mobile-atc-size-drawer');
            if (newButtons.length > 0) {
              setTimeout(initializeQuickShop, 500);
            }
          }
        }
      });
      setTimeout(() => {
        bindSkuListAddToCartButtons();
      setTimeout(() => {
      // Update the color count in .colorVariantCount elements
      document.querySelectorAll('.nosto-list-item .colorVariantCount').forEach(element => {
        if (!element.hasAttribute('data-count-updated')) {
          element.setAttribute('data-count-updated', 'true'); // Mark to prevent duplicate processing
          const value = element.textContent || "";
          const colorCount = value.split('|').length;
          if (colorCount > 1){ 
            element.textContent = `Colors +${colorCount - 1}`;
          } else {
            element.textContent = ``;
          }
        }
      });
    }, 600);
    }, 600);
    }
  });
});

// Start observing the document body for added nodes
observer.observe(document.body, { childList: true, subtree: true });

  bindSkuListAddToCartButtons();
});

function updateSniffieOmnibusPrice(variantId) {
  fetch(`/products/{{ product.handle }}?variant=${variantId}`)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const srcBlocks = doc.querySelectorAll('.sniffie-omnibus-price');
      const destBlocks = document.querySelectorAll('.sniffie-omnibus-price');
      if (!srcBlocks.length || !destBlocks.length) return;
      srcBlocks.forEach((src, i) => {
        if (destBlocks[i]) destBlocks[i].innerHTML = src.innerHTML;
      });
    }).catch(error => {
      console.error('Error updating sniffie omnibus price:', error);
    });
}



function initNoDrawerCheckoutCTA() {
  (function() {
  const VER = 'CNV-PDP NoDrawer Checkout CTA v1.6 (Nosto moves after ATC under .under-atc-text)';
  if (window.__cnvNoDrawerCheckoutCTA_v16) {
    console.warn(`[${VER}] already applied`);
    return;
  }
  window.__cnvNoDrawerCheckoutCTA_v16 = true;
  // Utils
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.prototype.slice.call(r.querySelectorAll(s));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts || false);
  const FORM_SEL = '.product-form, .product-single__form, form[action="/cart/add"]';
  // Styles
  (function injectStyle() {
    if (q('#cnv-nodrawer-style')) return;
    const css = `
      #cnv-checkout-cta { display:none; width:100%; clear:both; margin-top:10px; overflow:hidden; transition:max-height .25s ease; }
      #cnv-checkout-cta.cnv-open { display:block; max-height:160px; }
      #cnv-checkout-cta:not(.cnv-open) { max-height:0; }
      #cnv-checkout-cta .cnv-checkout-btn {
        display:block; width:100%; text-align:center;
        background:#000; color:#fff; border:0; border-radius:0px;
        padding:14px 16px; font-weight:600; cursor:pointer; text-decoration:none;
      }
      #cnv-checkout-cta .cnv-checkout-btn:focus { outline:2px solid #111; outline-offset:2px; }
      .cnv-nosto-below-cta { width:100% !important; display:block !important; clear:both !important; }
    `;
    const s = document.createElement('style');
    s.id = 'cnv-nodrawer-style';
    s.textContent = css;
    document.head.appendChild(s);
  })();
  // Checkout CTA
  function getCheckoutHref() {
    const candidates = [
      '#CartDrawer a[href*="/check"]',
      '.ajaxcart__checkout[href*="/check"]',
      '.mini-cart a[href*="/check"]',
      '.cart__checkout[href*="/check"]',
      'a.btn--checkout[href*="/check"]',
      'a[href^="/checkout"]'
    ];
    for (const sel of candidates) {
      const a = q(sel);
      if (a && a.getAttribute('href')) return a.getAttribute('href');
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'checkout';
  }
  function ensureCheckoutCTA() {
    const btnWrap = q('.pdp-button-container') || q(FORM_SEL);
    if (!btnWrap) return null;
    let cta = q('#cnv-checkout-cta', btnWrap) || q('#cnv-checkout-cta');
    if (!cta || (cta && cta.parentElement !== btnWrap)) {
      if (cta && cta.parentElement !== btnWrap) {
        btnWrap.appendChild(cta);
      } else if (!cta) {
        cta = document.createElement('div');
        cta.id = 'cnv-checkout-cta';
        const a = document.createElement('a');
        a.className = 'cnv-checkout-btn';
        a.textContent = quickshopCnvString("cnvCheckoutCta", "Go to checkout");
        a.href = getCheckoutHref();
        a.rel = 'nofollow';
        cta.appendChild(a);
        btnWrap.appendChild(cta);
      }
    } else {
      const a = cta.querySelector('.cnv-checkout-btn');
      if (a) a.href = getCheckoutHref();
    }
    return cta;
  }
  function revealCheckoutCTA() {
    const cta = ensureCheckoutCTA();
    if (cta) {
      const a = cta.querySelector('.cnv-checkout-btn');
      if (a) a.href = getCheckoutHref();
      cta.classList.add('cnv-open');
    }
  }
  // Nosto
  function getCandidateNostoEls() {
    const ids =
      typeof window.theme !== 'undefined' && typeof window.theme.getNostoMoveUnderCtaSelectors === 'function'
        ? window.theme.getNostoMoveUnderCtaSelectors()
        : [
            '#productpage_nosto_8',
            '#productpage-nosto-8',
            '#productpage-nosto_2',
            '#pdp-rec-bundle-1',
            '.nosto_element#pdp-rec-bundle-1',
            '#pdp-rec-1',
            '#pdp-rec-3',
            '#pdp-rec-4',
            '#pdp-rec-5',
            '.nosto_element#productpage_nosto_8',
            '.nosto_element#productpage-nosto-2'
          ];
    const found = ids.map(sel => q(sel)).filter(Boolean);
    qa('.product-single__meta .nosto_element').forEach(el => {
      if (!found.includes(el)) found.push(el);
    });
    return found;
  }
  function nostoHasContent(root) {
    if (!root) return false;
    const sel = [
      '.nosto-list-item',
      '.nosto-product',
      '.product, .grid-product, .product-card',
      'img[src], img[data-src], img[data-srcset]',
      'a[href*="/products/"]'
    ].join(',');
    if (root.querySelector(sel)) return true;
    const text = (root.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 80;
  }
  function refreshQuickShopNostoSliders(scope) {
    const refresh = () => resizeQuickShopNostoSliders(scope);

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(refresh);
    });
    window.setTimeout(refresh, 250);
    window.setTimeout(refresh, 800);
  }
  function moveNostoUnderATCTextWhenReady(timeoutMs = 15000) {
    const underAtc = q('.under-atc-text');
    if (!underAtc) return;
    const nostos = getCandidateNostoEls();
    if (!nostos.length) return;
    const doMove = (el) => {
      if (!el) return;
      el.classList.add('cnv-nosto-below-cta');
      underAtc.insertAdjacentElement('afterend', el);
      refreshQuickShopNostoSliders(el);
    };
    const ready = nostos.find(n => nostoHasContent(n));
    if (ready) {
      doMove(ready);
      return;
    }
    const observers = [];
    const stopAll = () => observers.forEach(o => o.disconnect());
    nostos.forEach(nosto => {
      const obs = new MutationObserver(() => {
        if (nostoHasContent(nosto)) {
          stopAll();
          doMove(nosto);
        }
      });
      obs.observe(nosto, {
        childList: true,
        subtree: true
      });
      observers.push(obs);
    });
    setTimeout(stopAll, timeoutMs);
  }
  // Variant handling
  function getCurrentVariantId(scope = document) {
    let cand = scope.querySelector('input[type="radio"][data-variant-id].selected') ||
      scope.querySelector('input[type="radio"][data-variant-id]:checked');
    if (cand && cand.getAttribute('data-variant-id')) return cand.getAttribute('data-variant-id');
    const checked = scope.querySelector('input[type="radio"]:checked');
    if (checked) {
      const wrapper = checked.closest('.variant-input');
      if (wrapper && wrapper.getAttribute('data-variant-id')) {
        return wrapper.getAttribute('data-variant-id');
      }
    }
    const selWrap = scope.querySelector('.variant-input.selected');
    if (selWrap && selWrap.getAttribute('data-variant-id')) {
      return selWrap.getAttribute('data-variant-id');
    }
    const sel = scope.querySelector('select[name="id"]');
    if (sel && sel.value) return sel.value;
    const hidden = scope.querySelector('input[name="id"]');
    if (hidden && hidden.value) return hidden.value;
    return null;
  }
  function syncVariantIdIntoForm(form) {
    if (!form) return null;
    const current = getCurrentVariantId(form) || getCurrentVariantId(document);
    if (!current) return null;
    const hidden = form.querySelector('input[name="id"]');
    const select = form.querySelector('select[name="id"]');
    if (hidden && hidden.value !== String(current)) hidden.value = String(current);
    if (select && select.value !== String(current)) select.value = String(current);
    return String(current);
  }
  // ATC UI states
  function setATCStateSuccess(form) {
    const atcBtn = form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]');
    if (!atcBtn) return;
    const txt = atcBtn.querySelector('[id^="AddToCartText-"]') || atcBtn;
    atcBtn.classList.add('cnv-atc-success');
    const original =
      txt.getAttribute('data-default-text') ||
      quickshopCnvString("cnvAddToCartDefault", "Add to cart");
    txt.setAttribute('data-original-text', original);
    const addedLabel = quickshopCnvString("cnvAddedToCart", "Added");
    const addedCount = Number(atcBtn.dataset.addedCount || 0) + 1;
    atcBtn.dataset.addedCount = String(addedCount);
    txt.textContent = addedCount > 1 ? addedLabel + ' × ' + addedCount : addedLabel;
    if (form.closest('.quickshop')) {
      atcBtn.classList.remove('is-added-pulse');
      void atcBtn.offsetWidth;
      atcBtn.classList.add('is-added-pulse');
    }
  }
  function resetATCState(form) {
    const atcBtn = form && (form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]'));
    if (!atcBtn) return;
    atcBtn.classList.remove('cnv-atc-success', 'is-added-pulse');
    delete atcBtn.dataset.addedCount;
    const txt = atcBtn.querySelector('[id^="AddToCartText-"]') || atcBtn;
    const def = (
      txt.getAttribute('data-default-text') ||
      txt.getAttribute('data-original-text') ||
      quickshopCnvString("cnvAddToCartDefault", "Add to cart")
    ).trim();
    txt.textContent = def;
    const cta = ensureCheckoutCTA();
    if (cta) cta.classList.remove('cnv-open');
  }
  function refreshCartQuietly() {
    try {
      fetch('/cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(r => r.ok ? r.json() : null)
        .then(cart => {
          if (!cart) return;
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: {
              cart
            }
          }));
          document.dispatchEvent(new CustomEvent('cart:build', {
            detail: {
              cart
            }
          }));
        })
        .catch(() => {});
    } catch (e) {}
  }
  // Drawer guard
  let guardUntil = 0;
  function armDrawerGuard(ms = 5000) {
    guardUntil = Date.now() + ms;
  }
  const CART_OPEN_SEL = [
    '.js-drawer-open-cart', '[data-action="open-drawer"]', '[data-drawer="cart"]',
    '[data-drawer-trigger="cart"]', '.cart-toggle', '.header-cart', '.site-header__cart-toggle'
  ].join(',');
  on(document, 'click', function(e) {
    const tgt = e.target && e.target.closest && e.target.closest(CART_OPEN_SEL);
    if (!tgt) return;
    if (Date.now() < guardUntil) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
  }, true);
  // Submit interception
  on(document, 'submit', function(e) {
    const form = e.target;
    if (!form || !form.matches(FORM_SEL)) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    const currentVariantId = syncVariantIdIntoForm(form);
    if (!currentVariantId) return;
    armDrawerGuard(5000);
    const atcBtn = form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]');
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');
    }
    const fd = new FormData(form);
    fd.set('id', String(currentVariantId));
    fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        setATCStateSuccess(form);
        revealCheckoutCTA();
        moveNostoUnderATCTextWhenReady(); // move after ATC only after add
        refreshCartQuietly();
        
      })
      .catch(err => {
        console.error('[NoDrawer] ATC error', err);
      })
      .finally(() => {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-busy');
        }
      });
  }, true);
  // Observe DOM (variant swaps, PJAX, async Nosto)
  (function observeProductArea() {
    const root = q('#productSection') || q('.combined-product') || q('.product-single__meta') || document.documentElement;
    const mo = new MutationObserver(() => {
      const form = q(FORM_SEL);
      if (form) syncVariantIdIntoForm(form);
      ensureCheckoutCTA();
    });
    mo.observe(root, {
      childList: true,
      subtree: true
    });
  })();
  // Variant change resets
  (function bindVariantReset() {
    const container = q('#productSection') || q('.product-single__meta') || document;
    on(container, 'change', function(e) {
      if (!e.target) return;
      if (e.target.matches('input[type="radio"], select')) {
        const form = q(FORM_SEL);
        syncVariantIdIntoForm(form);
        resetATCState(form);
        ensureCheckoutCTA();
      }
    }, true);
    on(document, 'variant:change', function() {
      const form = q(FORM_SEL);
      syncVariantIdIntoForm(form);
      resetATCState(form);
      ensureCheckoutCTA();
    });
    on(document, 'variantSwitched', function() {
      const form = q(FORM_SEL);
      syncVariantIdIntoForm(form);
      resetATCState(form);
      ensureCheckoutCTA();
    });
  })();
  // Boot
  (function boot() {
    const form = q(FORM_SEL);
    if (form) syncVariantIdIntoForm(form);
    ensureCheckoutCTA();
  })();


})();
}
